import { useEffect, useState } from "react";
import { TrendingUp } from "lucide-react";
import { api } from "../../lib/api";

export const Ticker = () => {
  const [items, setItems] = useState(["Loading live market data…"]);

  useEffect(() => {
    api.stats().then((s) => setItems(s.ticker)).catch(() => {});
  }, []);

  const doubled = [...items, ...items];

  return (
    <div
      data-testid="announcement-ticker"
      className="relative z-30 flex w-full items-stretch border-b border-sky-400/30 bg-[#031018]"
    >
      {/* live tag */}
      <div className="flex flex-shrink-0 items-center gap-2 border-r border-sky-400/30 bg-sky-400 px-4 text-[#031018]">
        <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-[#031018]" />
        <span className="font-mono text-xs font-bold uppercase tracking-widest">Live</span>
      </div>
      {/* tape */}
      <div className="ticker-wrap flex-1 overflow-hidden">
        <div className="flex w-max animate-marquee items-center py-2">
          {doubled.map((t, i) => (
            <span
              key={`${i}-${t}`}
              className="flex items-center gap-2 whitespace-nowrap px-6 font-mono text-xs tracking-tight text-sky-400"
            >
              <TrendingUp className="h-3.5 w-3.5" />
              <span className="text-sky-100">{t}</span>
              <span className="text-sky-400/40">•</span>
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Ticker;
